import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	toolchain: {
		id: 'spa-apps-sidebar-software-classic.menu.settings.toolchain-menu-item.toolchain',
		defaultMessage: 'Toolchain',
		description: 'Nav item label for toolchain overview in a software project',
	},
});
